import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { shouldShowApplyButton } from 'app/shared/utils/cometUtils';
import { ContactFormSpoke } from '../ContactForm/ContactFormSpoke';
import { ApplyInterstitial } from './ApplyInterstitial';

type ApplySpokeProps = {
  onClose: () => void;
  listing?: ListingDetails;
};

export const ApplySpoke = ({ onClose, listing: listingProp }: ApplySpokeProps) => {
  const reduxListing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);
  const isMobile = useSelector((state: RootReduxState) => state.app.device.screenWidth === 'sm');
  const listing = listingProp || reduxListing;

  if (!listing) {
    return null;
  }

  const acceptsApplications = shouldShowApplyButton(listing.rentalApplicationStatus);

  if (acceptsApplications) {
    return <ApplyInterstitial propertyId={listing.aliasEncoded} isMobile={isMobile} />;
  }

  return <ContactFormSpoke onClose={onClose} listing={listing} mode="requestToApply" />;
};
